import { Store, Sparkles, User, Settings } from 'lucide-react';

const tabs = [
    { id: 'businesses', icon: Store, label: 'İşletmeler' },
    { id: 'explore', icon: Sparkles, label: 'Kampanyalar' },
    { id: 'profile', icon: User, label: 'Profil' },
    { id: 'settings', icon: Settings, label: 'Ayarlar' },
];

const GlobalBottomNav = ({ activeTab, setActiveTab, primaryColor }) => {
    return (
        <div style={{
            position: 'fixed',
            bottom: '1rem',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 'calc(100% - 2rem)',
            maxWidth: '420px',
            padding: '6px',
            borderRadius: '20px',
            background: 'rgba(255,255,255,0.92)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            zIndex: 100,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.06)',
            border: '1px solid rgba(0,0,0,0.06)'
        }}>
            {tabs.map(tab => {
                const isActive = activeTab === tab.id;
                return (
                    <div
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: isActive ? '6px' : '0',
                            color: isActive ? 'white' : '#9ca3af',
                            padding: isActive ? '10px 18px' : '10px 14px',
                            borderRadius: '16px',
                            background: isActive ? primaryColor : 'transparent',
                            cursor: 'pointer',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            boxShadow: isActive ? `0 4px 12px ${primaryColor}40` : 'none',
                        }}
                    >
                        <tab.icon size={20} strokeWidth={isActive ? 2.5 : 2} />
                        {isActive && (
                            <span style={{ fontSize: '0.7rem', fontWeight: 800, whiteSpace: 'nowrap' }}>{tab.label}</span>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default GlobalBottomNav;
